import { Link } from 'gatsby';
import React, { useEffect, useState } from 'react';
import logo from "../../../../../static/utekirkelogokors.png";
import {
  PATH_ADMIN_CREATORS,
  PATH_CREATOR_TEMPLATES,
  PATH_QUESTION_LIBRARY,
  PATH_CLOSED_TRAILS,
  PATH_ACTIVITY_LIBRARY,
  PATH_OVERVIEW,
  PATH_GAME_BUILDER,
  PATH_ACCOUNT,
  PAGE_OVERVIEW,
  PAGE_MY_ACTIVITES,
  PAGE_ACTIVITY_LIBRARY,
  PAGE_QUESTION_LIBRARY,
  PAGE_CLOSED_TRAILS,
  PAGE_ADMIN,
} from '../../../../constants/routes';
import useFirebase from '../../../../hooks/useFirebase';
import {
    navSidebarTitles,
    alertMessages,
    TRIAL_ENABLED,
    TRIAL_DAYS,
} from '../../../variables/variables';
import { TrialModal } from '../../AuthModules/TrialModal';
import SignOutButton from './SignOutButton';
import {
    GrMapLocation,
    GrVend,
    GrCircleQuestion,
    GrCatalog,
    GrCatalogOption,
    GrShield,
    GrMap,
} from 'react-icons/gr';
// Icons: GrTrophy, GrScorecard, GrRun,
// Abstract: GrVirtualMachine, GrTarget, GrTemplate, GrTasks, GrTable, GrSidebar, GrSelection, GrResources, GrNotes, GrMultiple, GrMap, GrLocation, GrHome, GrTreeOption, GrCopy, GrClone,
// Library: GrCatalogOption
// My activities: GrBook
// My finished: GrArchive
const activeStyle = {
  boxShadow: "inset -4px 0px 0px 0px #E42A3C",
  background: "#ffe2e6",
  color: "#E42A3C",
};

// 86 400 000 = milliseconds in one day
const millisOneDay = 86400000;

const NavigationAuth = (_authUser) => {
  const [page, setPage] = useState(null);
  const [superAdmin, setSuperAdmin] = useState(false);
  const [trialStarted, setTrialStarted] = useState(undefined);
  const [trialModal, setTrialModal] = useState(false);

  const firebase = useFirebase();

  function confirmNavigation(e) {
    const path =
      typeof window !== 'undefined' ? window.location.pathname : '';
    if (path === PATH_GAME_BUILDER && !window.confirm(alertMessages.confirmExitPage)) {
      e.preventDefault();
    }
  }

  useEffect(() => {
    if (!firebase) return;
    setSuperAdmin(firebase.superAdmin);
    setTrialStarted(firebase.trialStarted);
  }, [firebase]);

  useEffect(() => {
    const path = window && window.location.pathname;
    if (path.includes(PATH_OVERVIEW)) {
      setPage(PAGE_OVERVIEW);
    } else if (path.includes(PATH_CREATOR_TEMPLATES)) {
      setPage(PAGE_MY_ACTIVITES);
    } else if (path.includes(PATH_ACTIVITY_LIBRARY)) {
      setPage(PAGE_ACTIVITY_LIBRARY);
    } else if (path.includes(PATH_QUESTION_LIBRARY)) {
      setPage(PAGE_QUESTION_LIBRARY);
    } else if (path.includes(PATH_CLOSED_TRAILS)) {
      setPage(PAGE_CLOSED_TRAILS);
    } else if (path.includes(PATH_ADMIN_CREATORS)) {
      setPage(PAGE_ADMIN);
    }
  }, [setPage]);

  useEffect(() => {
      if (!firebase) return;
      if (trialStarted !== undefined && TRIAL_ENABLED) {
         // Don't show the reminder too often, i.e. only once per day at most.
         if (localStorage.getItem('onTrialReminder') !== null) {
          const lastShown = new Date(localStorage.getItem('onTrialReminder'));
          // 86 400 000 = milliseconds in one day
          if (new Date().getTime() - lastShown.getTime() > millisOneDay) {
            localStorage.setItem('onTrialReminder', new Date().toJSON());
            setTrialModal(true);
          }
        } else {
          localStorage.setItem('onTrialReminder', new Date().toJSON());
          setTrialModal(true);
        }
        const difference = new Date().getTime() - trialStarted.getTime();
        const daysRemaining = TRIAL_DAYS - Math.round(difference / millisOneDay);
        localStorage.setItem('hasTrialPeriodExpired', (daysRemaining < 0));
      } else {
        // If not enabled or the trial period is not applicable then remove the variable.
        localStorage.removeItem('hasTrialPeriodExpired');
      }
  }, [trialModal, firebase, trialStarted]);

  return (
    <div className="navbar" style={{ zIndex: '1' }}>
      <div className="navbar__inner">
        <div className="navbar__logo">
          <Link to={PATH_OVERVIEW}>
            <img src={logo} alt="utekirke logo" />
          </Link>
        </div>
        <div className="navbar__left">
          <div className="navbar__links">
            <Link to={PATH_GAME_BUILDER} style={{marginLeft: '-6px', marginBottom: '2rem'}}>
              <div className="navbar__new-game-button">
                {React.createElement(GrMapLocation, {
                  className: 'navbar__links__icon',
                  style: { filter: 'invert(1)' },
                })}
                <span className='navbar__links__text'>{navSidebarTitles.titleNewTemplate}</span>
              </div>
            </Link>
            <Link
              to={PATH_OVERVIEW}
              activeStyle={activeStyle}
              onClick={(e) => confirmNavigation(e)}
             >
              {page === PAGE_OVERVIEW ?
                React.createElement(GrMap, {
                  className: 'navbar__links__icon',
                })
              :
                React.createElement(GrMap, {
                  className: 'navbar__links__icon',
                  style: {
                    filter: 'brightness(50%)',
                  },
                })
              }
              <span className='navbar__links__text'>{navSidebarTitles.titleOverview}</span>
            </Link>
            <Link
              to={PATH_CREATOR_TEMPLATES}
              activeStyle={activeStyle}
              onClick={(e) => confirmNavigation(e)}
             >
              {page === PAGE_MY_ACTIVITES ?
                React.createElement(GrCatalog, {
                  className: 'navbar__links__icon',
                })
              :
                React.createElement(GrCatalog, {
                  className: 'navbar__links__icon',
                  style: {
                    filter: 'brightness(50%)',
                  },
                })
              }
              <span className='navbar__links__text'>{navSidebarTitles.titleCreatorTemplates}</span>
            </Link>
            <Link
              to={PATH_ACTIVITY_LIBRARY}
              activeStyle={activeStyle}
              onClick={(e) => confirmNavigation(e)}
             >
              {page === PAGE_ACTIVITY_LIBRARY ?
                React.createElement(GrVend, {
                  className: 'navbar__links__icon',
                })
              :
                React.createElement(GrVend, {
                  className: 'navbar__links__icon',
                  style: {
                    filter: 'brightness(50%)',
                  },
                })
              }
              <span className='navbar__links__text'>{navSidebarTitles.titleUtekirkeTemplates}</span>
            </Link>
            <Link
              to={PATH_QUESTION_LIBRARY}
              activeStyle={activeStyle}
              onClick={(e) => confirmNavigation(e)}
             >
              {page === PAGE_QUESTION_LIBRARY ?
                React.createElement(GrCircleQuestion, {
                  className: 'navbar__links__icon',
                })
              :
                React.createElement(GrCircleQuestion, {
                  className: 'navbar__links__icon',
                  style: {
                    filter: 'brightness(50%)',
                  },
                })
              }
              <span className='navbar__links__text'>{navSidebarTitles.titleQuestionLibrary}</span>
            </Link>
            <Link
              to={PATH_CLOSED_TRAILS}
              activeStyle={activeStyle}
              onClick={(e) => confirmNavigation(e)}
             >
              {page === PAGE_CLOSED_TRAILS ?
                React.createElement(GrCatalogOption, {
                  className: 'navbar__links__icon',
                })
              :
                React.createElement(GrCatalogOption, {
                  className: 'navbar__links__icon',
                  style: {
                    filter: 'brightness(50%)',
                  },
                })
              }
              <span className='navbar__links__text'>{navSidebarTitles.titleClosedTrails}</span>
            </Link>
            {superAdmin === true && (
              <Link
                to={PATH_ADMIN_CREATORS}
                activeStyle={activeStyle}
                onClick={(e) => confirmNavigation(e)}
               >
              {page === PAGE_ADMIN ?
                React.createElement(GrShield, {
                  className: 'navbar__links__icon',
                })
              :
                React.createElement(GrShield, {
                  className: 'navbar__links__icon',
                  style: {
                    filter: 'brightness(50%)',
                  },
                })
              }
              <span className='navbar__links__text'>Adminpanel</span>
              </Link>
            )}
          </div>
        </div>

        <div className="navbar__user">
          <Link
            to={PATH_ACCOUNT}
            style={{
              minHeight: '70px',
              color: '#59b9eb',
              padding: '2px',
              textDecoration: 'none',
            }}
           >
            <div className={'signout-btn'}>
              Mine opplysninger
            </div>
          </Link>
          <div className="navbar__item">
            <SignOutButton />
          </div>
        </div>
        <div style={{ margin: '15px 0' }}>
          <div>
            <a
              href="https://www.utekirke.no"
              target="_blank"
              rel="noreferrer"
              style={{
                color: '#59B9EB',
                fontSize: '0.8rem',
                padding: '2px',
                textDecoration: 'none',
              }}
            >
              Utekirke AS
            </a>
          </div>
          <div
            style={{
              color: '#969BA0',
              fontSize: '0.8rem',
              padding: '2px',
              marginBottom: '10px',
            }}
           >
            &copy;{new Date().getFullYear()} alle rettigheter forbeholdt
          </div>
          <div
            style={{
              color: '#59B9EB',
              fontSize: '0.8rem',
              padding: '2px',
            }}
           >
            <a
              href="https://utekirke.no/personvern-og-bruksvilkar.html"
              target="_blank"
              rel="noreferrer"
              style={{
                color: '#59B9EB',
                fontSize: '0.8rem',
                padding: '2px',
                textDecoration: 'none',
              }}
             >Personvernerklæring</a>
          </div>
        </div>
      </div>
      <TrialModal
        isOpen={trialModal}
        onCancel={() => setTrialModal(false)}
        onConfirm={() => setTrialModal(false)}
        trialStarted={trialStarted}
       />
    </div>
  );
};

export default NavigationAuth;
